import { setHiddenSlides } from '../../../../src/js/utils/functions';

document.querySelectorAll<HTMLElement>('.testimonial-slider').forEach((slider) => {
	const wrapper = slider.querySelector<HTMLElement>('.testimonial-slider__wrapper');

	if (null !== wrapper) {
		new (window as Window).Swiper(wrapper, {
			a11y: {
				slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
			},
			on: {
				init: setHiddenSlides,
				slideChangeTransitionEnd: setHiddenSlides,
				breakpoint: setHiddenSlides,
			},
			slidesPerView: 1,
			loop: true,
			navigation: {
				nextEl: slider.querySelector('.testimonial-pagination__button--next'),
				prevEl: slider.querySelector('.testimonial-pagination__button--prev'),
			},
		});
	}
});
